import { ValidatorFn } from '@angular/forms';

export declare type ControlType = 'input' | 'select' | 'textarea' | 'checkbox';

export declare type DynamicGroup = DynamicFormControl<any> | DynamicInputGroup;

export abstract class DynamicFormControl<T> {

  constructor(public value?: T,
              public key?: string,
              public placeholder?: string,
              public validators?: ValidatorFn[],
              public order: number = 1,
              public controlType?: ControlType) {
  }
}

export class DynamicInputGroup {

  public readonly controlType = 'group';

  layout: 'column' | 'row' = 'column';

  constructor(public group: Map<string, DynamicFormControl<any>>) {
  }
}

export class DynamicInput extends DynamicFormControl<string> {

  public controlType: ControlType = 'input';

}

export class DynamicSelect<T> extends DynamicFormControl<string> {

  public controlType: ControlType = 'select';

  public options: T[];

}

export class DynamicTextarea extends DynamicFormControl<string> {

  public controlType: ControlType = 'textarea';

}

export class DynamicCheckbox extends DynamicFormControl<boolean> {

  public controlType: ControlType = 'checkbox';

}
